import type { MetaTrackEvent } from '@repo/single-spa';
import { clearAttribution } from '@repo/utils';

import type { Fbq, MetaPixelWindow } from '.';

// One standard event through the Pixel; eventID pairs it with the server copy
export function trackMetaEvent(
  { event, eventId }: MetaTrackEvent,
  fbq: Fbq | undefined = (window as MetaPixelWindow).fbq
): void {
  if (typeof fbq !== 'function') {
    return;
  }
  if (eventId) {
    fbq('track', event, {}, { eventID: eventId });
  } else {
    fbq('track', event, {});
  }
}

/**
 * Sign up is confirmed: track it, then drop the campaign this bundle may still hold
 * in memory from before consent, so a later yes does not store it again.
 */
export function handleSignUpConfirmTrack(
  event: MetaTrackEvent,
  fbq: Fbq | undefined = (window as MetaPixelWindow).fbq
): void {
  try {
    trackMetaEvent(event, fbq);
  } finally {
    clearAttribution();
  }
}
